/*
 * @Author: wuhao
 * @Date: 2020-04-08 14:28:17
 * @LastEditors: wuhao
 * @LastEditTime: 2021-03-02 10:57:46
 * @Description: 封装table搜索条件
 */

import ApexDatePicker from './src/index'

ApexDatePicker.install = function(Vue) {
  Vue.component(ApexDatePicker.name, ApexDatePicker)
}

export default ApexDatePicker
